<script>
export default {
	inheritAttrs: false
};
</script>

<script setup>
import { onMounted, onUnmounted } from "vue";

defineEmits(["close"]);

onMounted(() => {
	document.body.style.overflow = "hidden";
});

onUnmounted(() => {
	document.body.style.overflow = null;
});
</script>

<template>
	<Teleport to="body">
		<div v-bind="$attrs" class="vui-backdrop" @mousedown.left.self="$event.clientX < $event.target.clientWidth && $emit('close')">
			<slot></slot>
		</div>
	</Teleport>
</template>
